import * as ApiManager from './_manager';

export const consumer = {
  subscribeNewsletter: payload => {
    return ApiManager.callApi('/consumer/subscribeNewsletter', payload);
  },
};
